"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'conversations.search.placeholder': 'Search conversations...',
};
